import React from 'react'
import { Classes, Tag } from '@blueprintjs/core'
import { HighlightedText, ColorSquare } from '..'
import GenericSelectWithInfiniteScroll, {
  SelectProps,
  ItemProps,
} from './GenericSelectWithInfiniteScroll'
import api, { IDepartment } from '@api'

type DepartmentSelectProps = SelectProps<IDepartment>

export default function DepartmentSelect(props: DepartmentSelectProps) {
  return (
    <GenericSelectWithInfiniteScroll<IDepartment>
      {...props}
      list={api.department.search}
      Item={DepartmentItem}
    />
  )
}

export function DepartmentItem({ type, data, refItem, query }: ItemProps<IDepartment>) {
  if (type === 'skeleton') {
    return (
      <div className="flex flow-grow items-center py-1">
        <ColorSquare skeleton />
        <div className="ml-2">
          <span className={Classes.SKELETON}>First Last name</span>
        </div>
      </div>
    )
  }

  const { color, name, parentDepartment } = data as IDepartment

  return (
    <div ref={refItem} className="flex flex-col justify-center flex-grow truncate">
      <div className="flex justify-between">
        <div className="flex items-center truncate">
          <ColorSquare style={{ background: `#${color}` }} />
          <div className="ml-2 truncate">
            <HighlightedText query={query} text={name} test={name} />
          </div>
        </div>
        {type !== 'value' && parentDepartment && (
          <Tag minimal round className="flex-shrink-0">
            Team
          </Tag>
        )}
      </div>
      {type !== 'value' && parentDepartment && (
        <div className="flex items-center text-xs text-grey-600">
          <div className="ml-6 flex-grow truncate leading-tight">{parentDepartment.name}</div>
        </div>
      )}
    </div>
  )
}
